import { c as _c } from "react-compiler-runtime";
import * as React from "react";
import { FieldErrorContext } from "react-aria-components";
import { jsx as _jsx } from "react/jsx-runtime";
const StyleContext = /*#__PURE__*/React.createContext({
  style: "modern",
  defaultLabelStyle: "default"
});
export const StyleProvider = t0 => {
  const $ = _c(5);
  const {
    defaultLabelStyle: t1,
    children
  } = t0;
  const defaultLabelStyle = t1 === undefined ? "default" : t1;
  let t2;
  if ($[0] !== defaultLabelStyle) {
    t2 = {
      style: "modern",
      defaultLabelStyle
    };
    $[0] = defaultLabelStyle;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const value = t2;
  let t3;
  if ($[2] !== children || $[3] !== value) {
    t3 = /*#__PURE__*/_jsx(StyleContext.Provider, {
      value: value,
      children: children
    });
    $[2] = children;
    $[3] = value;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};

/**
 * @deprecated We've removed the legacy style, so this hook is no longer needed.
 */
// eslint-disable-next-line @eslint-react/no-unnecessary-use-prefix
export function useStyle() {
  return "modern";
}
export function useDefaultLabelStyle() {
  const {
    defaultLabelStyle
  } = React.useContext(StyleContext);
  return defaultLabelStyle;
}
export function useNullableContext(context) {
  return React.useContext(context);
}
export function useFieldErrorContext() {
  return useNullableContext(FieldErrorContext);
}
//# sourceMappingURL=context.js.map